import React from 'react';
import Select from 'react-select';
import { Form, Col, Row } from 'react-bootstrap';
import './FollowUpFilterForm.scss';

interface FollowUpFilterFormProps {
    orgNumber: string;
    setOrgNumber: React.Dispatch<React.SetStateAction<string>>;
    name: string;
    setName: React.Dispatch<React.SetStateAction<string>>;
    status: string;
    setStatus: React.Dispatch<React.SetStateAction<string>>;
    isSendingTable: boolean;
    nameOptions: { value: string; label: string }[];
    orgNumberOptions: { value: string; label: string }[];
    isHandled: string;  // New prop
    setIsHandled: React.Dispatch<React.SetStateAction<string>>;
}

const FollowUpFilterForm: React.FC<FollowUpFilterFormProps> = ({
    orgNumber,
    setOrgNumber,
    name,
    setName,
    status,
    setStatus,
    isSendingTable,
    nameOptions,
    orgNumberOptions,
    isHandled,
    setIsHandled
}) => {
    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            borderColor: state.isFocused ? '#f8b133' : provided.borderColor,
            '&:hover': {
                borderColor: state.isFocused ? '#f8b133' : provided.borderColor,
            },
            boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(248, 177, 51, .25)' : provided.boxShadow,
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#f8b133'
                : state.isFocused
                    ? 'rgba(248, 177, 51, 0.75)' // 50% transparency
                    : undefined,
            color: state.isSelected ? '#fff' : '#000', // Keep text black when focused/hovered
        }),
        menu: (provided: any) => ({
            ...provided,
            zIndex: 1050 // Higher z-index for the dropdown menu
        })
    };

    return (
        <Form className="common-filter-form">
            <Form.Group className="filter-group" controlId="name">
                <Form.Label>{isSendingTable ? 'Kundnamn' : 'Leverantörsnamn'}</Form.Label>
                <Select
                    options={nameOptions}
                    value={nameOptions.find(option => option.value === name) || null}
                    onChange={(selectedOption) => setName(selectedOption ? selectedOption.value : '')}
                    placeholder={`Ange ${isSendingTable ? 'kundnamn' : 'leverantörsnamn'}`}
                    isClearable
                    isSearchable
                    styles={customStyles} // Apply the custom styles here
                />
            </Form.Group>

            <Form.Group className="filter-group" controlId="orgNumber">
                <Form.Label>Organisationsnummer</Form.Label>
                <Select
                    options={orgNumberOptions}
                    value={orgNumberOptions.find(option => option.value === orgNumber) || null}
                    onChange={(selectedOption) => setOrgNumber(selectedOption ? selectedOption.value : '')}
                    placeholder="Ange organisationsnummer"
                    isClearable
                    isSearchable
                    styles={customStyles} // Apply the custom styles here
                />
            </Form.Group>

            {isSendingTable && (
                <>
                    <Form.Group className="filter-group" controlId="status">
                        <Form.Label>Status</Form.Label>
                        <Form.Control as="select" value={status} onChange={(e) => setStatus(e.target.value)}>
                            <option value="">Alla</option>
                            <option value="0">Skickat</option>
                            <option value="1">Öppnat</option>
                            <option value="2">Godkänt</option>
                            <option value="3">Avvikelse</option>
                            <option value="4">Fått fakturor</option>
                        </Form.Control>
                    </Form.Group>

                    {/* New Slutförd filter dropdown */}
                    <Form.Group className="filter-group" controlId="isHandled">
                        <Form.Label>Slutförd</Form.Label>
                        <Form.Control as="select" value={isHandled} onChange={(e) => setIsHandled(e.target.value)}>
                            <option value="all">Alla</option>
                            <option value="handled">Slutförd</option>
                            <option value="unhandled">Ej slutförd</option>
                        </Form.Control>
                    </Form.Group>
                </>
            )}
        </Form>
    );
};

export default FollowUpFilterForm;
